import Select, { components } from 'react-select'
import { useContext, useEffect, useState } from "react";
import { ContentState, EditorState, convertFromHTML, convertToRaw } from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import CreatableSelect from 'react-select/creatable';
import { BiEdit } from 'react-icons/bi'
import { FiLink } from 'react-icons/fi'
import debounce from "lodash.debounce";
import { v4 as uuidv4 } from 'uuid';
import DOMPurify from "dompurify";
import { Loader } from 'rsuite';
import draftToHtml from "draftjs-to-html";
import { useDispatch } from 'react-redux';
import { LuPaperclip } from "react-icons/lu";
import { ImCross } from "react-icons/im";
import { Modal, Table } from 'rsuite';

import { getEmailListForUser, saveEmailDetails, sendEmailByGoogle, sendEmailByMicrosoft } from '../../redux/actions/emailSettings';
import { toast } from '../CommonComponents/ToastComponent/toast';
import { createContact, getExistingContacts, updateSupplierContact } from '../../redux/actions/contact';
import CreateContact from '../ContactsComponent/createContact';
import { useCallback } from 'react';
import { convertContentToHtml, getFileExtension } from '../../services/helper';
import { AppContext } from '../../context';
import { CONSTANTS } from '../../utils/constants/constants';

const { Cell } = Table

export const LinkCell = ({ rowData, dataKey, emailArea, onContactSelected, onClick, currentTab, isLoading = false, ...props }) => {
    return (
        <Cell {...props} className="table-link" style={{ border: "1px solid black" }} onClick={() => { onContactSelected(emailArea, rowData?.value) }}>
            <button className='text-primary' type="button" disabled={dataKey === 'suppliername' && isLoading}>
                {rowData[dataKey]}
            </button>
        </Cell>
    )
}

const ComposeEmail = ({
    componentFor = '',
    setShowComposeEmailBox = () => { },
    supplierInfo = {},
    vendorInfo = {},
    vendorInCallDetailsId,
    contacts,
    getContactsData,
    activeTab,
    actionOnEmailForTask,
    setCurrentTab,
    setShow,
    vendorId,
    selectedFormatedEmail,
    onClose = () => { } }) => {

    const dispatch = useDispatch()
    const {
        setInputEmailFrom,
        setInputEmailTo,
        setInputEmailCc,
        setInputEmailBcc,
        inputEmailFrom,
        inputEmailTo,
        inputEmailCc,
        inputEmailBcc,
        setSubject,
        subject,
        setEditorState,
        editorState,
        oldEmailDataInContext,
        actionOnEmail,
        parentThread,
        emailConversation,
        forwardConversation,
    } = useContext(AppContext);

    const [emailEntered, setEmailEntered] = useState('')
    const [showModal, setShowModal] = useState(false)
    const [showFrom, setShowFrom] = useState(false)
    const [showCC, setShowCC] = useState(false)
    const [showBCC, setShowBCC] = useState(false)
    // const [showContact, setShowContact] = useState(false)
    const [inputEmail, setInputEmail] = useState([])

    const [activeEmailField, setEmailActiveField] = useState('')
    const [allContacts, setAllContacts] = useState([])
    const [existingContacts, setExistingContacts] = useState([])
    const [showLinkModal, setShowLinkModal] = useState(false)
    const [supplierContacts, setSupplierContacts] = useState([])
    const [isContactLinkedWithSup, setIsContactLinkedWithSup] = useState([])
    const [isContactLinkedWithLs, setIsContactLinkedWithLs] = useState([])
    const [isEdit, setIsEdit] = useState(false)
    const [contactIdToEdit, setContactIdToEdit] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [input, setInput] = useState('')
    const [userDefaultEmail, setUserDefaultEmail] = useState(null)
    const [userRegisteredEmails, setUserRegisteredEmails] = useState([])
    const [existingContactId, setexistingContactId] = useState('')
    const [showThread, setShowThread] = useState(false)
    const [isSendingEmail, setIsSendingEmail] = useState(false)
    const [showSignature, setShowSignature] = useState(false)
    const [attachments, setAttachments] = useState([]);
    const [initialAllContacts, setInitialAllContacts] = useState([]);

    const removeFile = (name) => {
        let tmpFiles = attachments?.filter(attachment => attachment.filename !== name)
        setAttachments(tmpFiles)
    }

    const setInputEmailHandler = (oldEmailData) => {
        if (Object.keys(oldEmailData)?.length) {
            setSubject(`${oldEmailData?.subject}` || '')

            const result = contacts
                .filter(contact => contact?.email?.toLowerCase() === oldEmailData?.senderEmail?.toLowerCase()) // Find matching contacts
                .map(contact => ({
                    label: contact.email,
                    name: `${contact.firstname} ${contact.lastname}`.trim(),
                    value: contact.id
                }));
            setInputEmailTo(result)
        }
    }

    const onEditorStateChange = async (state) => {
        await setEditorState(state);
    }

    const handleFileUpload = async (event) => {
        const files = event.target.files;
        let uploadedFiles = [];

        for (let file of files) {
            let fileSizeMB = file.size / (1024 * 1024); // Convert bytes to MB
            if (fileSizeMB > 20) {
                toast.show({
                    title: 'Warning',
                    description: 'File size is more than 20 mb'
                })
                return
            }
            let base64Data = await fileToBase64(file);

            let mimeType = file.type;
            if (file.name.endsWith('.zip')) {
                mimeType = "application/zip";
            } else if (file.name.endsWith('.rar')) {
                mimeType = "application/x-rar-compressed";
            }

            uploadedFiles.push({
                filename: file.name,
                mimeType: mimeType || "application/octet-stream",
                data: base64Data
            });
        }

        setAttachments(uploadedFiles);
    };

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(',')[1]); // Extract Base64 content
            reader.onerror = (error) => reject(error);
        });
    };

    const onSendEmail = async () => {
        if (!subject) {
            toast.show({
                title: 'Warning',
                description: 'Please Add Subject For Email'
            })
            return
        }

        setIsSendingEmail(true)
        let tmpSender = userRegisteredEmails?.filter((registeredEmail) => registeredEmail?.label === inputEmailFrom?.label)[0]
        let uuid = uuidv4()
        const contentState = editorState.getCurrentContent();
        const editorContentHtml = draftToHtml(convertToRaw(contentState));
        const tempElement = document.createElement('div');
        tempElement.innerHTML = editorContentHtml;

        const paragraphs = tempElement.querySelectorAll('p');

        paragraphs.forEach(paragraph => {
            const textContent = paragraph.innerHTML;
            if (textContent.includes('http')) {
                const updatedUrl = `${textContent}?emailMessageId=${uuid}&domain=${userDefaultEmail?.domain}`;
                paragraph.innerHTML = `<a href="${updatedUrl}" target="_blank" rel="noopener noreferrer">Please visit this link</a>`;
            }
        });

        const updatedEditorContentHtml = tempElement.innerHTML;
        const emailMessage = {
            message: {
                subject: subject.trim(),
                body: {
                    contentType: 'HTML',
                    content: actionOnEmail === 'forward' ? `<div><p>---------Forwarded---------</p>\n${updatedEditorContentHtml + '<br>' + tmpSender?.emailSignature}</div>` : updatedEditorContentHtml + '<br>' + tmpSender?.emailSignature
                },
                internetMessageHeaders: [
                    {
                        name: "X-UUID",
                        value: uuid,
                    }, {
                        name: "X-DOMAIN",
                        value: userDefaultEmail?.domain,
                    }
                ],
                toRecipients: inputEmailTo?.map(email => ({
                    emailAddress: { address: email?.label },
                }))
            },
            saveToSentItems: true,
        };

        if (inputEmailFrom?.domain === "google") {
            emailMessage['attachments'] = attachments.map(file => {
                return {
                    name: file.filename.includes('.') ? file.filename : `${file.filename}.${getFileExtension(file.mimeType)}`,
                    mimeType: file.mimeType || "application/octet-stream",
                    data: file.data,
                }
            });
        } else if (inputEmailFrom?.domain === "microsoft") {
            emailMessage.message['attachments'] = attachments.map(file => {
                return {
                    "@odata.type": "#microsoft.graph.fileAttachment",
                    name: file.filename.includes('.') ? file.filename : `${file.filename}.${getFileExtension(file.mimeType)}`,
                    contentType: file.mimeType || "application/octet-stream",
                    contentBytes: file.data,
                }
            })
        }

        if (showCC) {
            emailMessage.message['bccRecipients'] = inputEmailBcc?.map(email => ({
                emailAddress: { address: email?.label },
            }))
        }

        if (showBCC) {
            emailMessage.message['ccRecipients'] = inputEmailCc?.map(email => ({
                emailAddress: { address: email?.label },
            }))
        }

        let type = '';
        let msgId = '';
        if (actionOnEmail === 'reply') {
            type = 'reply';
            msgId = parentThread;
        }

        if (inputEmailFrom?.domain === "google") {
            dispatch(sendEmailByGoogle({ composedEmail: emailMessage, accessToken: tmpSender?.accessToken, refreshToken: tmpSender?.refreshToken, email: tmpSender?.label, type, msgId })).then(async (res) => {
                setIsSendingEmail(false)
                let emailId = res?.messageId
                let threadId = res?.threadId

                await dispatch(saveEmailDetails(userDefaultEmail?.id, tmpSender?.domain, null, vendorId, emailId, true, false, null, null, null, threadId))
                    .then((res) => {
                        toast.show({
                            title: 'Success',
                            description: CONSTANTS.TOAST_MESSAGES.SUCCESS.EMAIL_DETAILS_SAVED
                        })
                    })
                    .catch((err) => {
                        toast.show({
                            title: 'Danger',
                            description: CONSTANTS.TOAST_MESSAGES.DANGER.EMAIL_DETAILS_SAVED_ERROR
                        })
                    })

                if (res?.response?.status === 200) {
                    toast.show({
                        title: 'Success',
                        description: CONSTANTS.TOAST_MESSAGES.SUCCESS.EMAIL_SENT
                    })
                    setInputEmailTo([])
                    setInputEmailCc([])
                    setInputEmailBcc([])
                    setSubject('')
                    setAttachments([])
                    setEditorState(EditorState.createEmpty());
                    if (!actionOnEmail === 'reply') {
                        setCurrentTab('all')
                    }
                    onClose(true, true)
                    return
                }
            }).catch((err) => {
                setIsSendingEmail(false)

                toast.show({
                    title: 'Danger',
                    description: 'Unable To Sent Email'
                })
                return
            })
            setShowComposeEmailBox(false)
        } else {
            dispatch(sendEmailByMicrosoft({ composedEmail: emailMessage, accessToken: tmpSender?.accessToken, email: tmpSender?.label, type, msgId })).then(async (res) => {
                setIsSendingEmail(false)
                let conversationId = res?.conversationId
                await dispatch(saveEmailDetails(userDefaultEmail?.id, tmpSender?.domain, null, vendorId, uuid, true, false, null, null, null, conversationId))
                    .then((res) => {
                        toast.show({
                            title: 'Success',
                            description: CONSTANTS.TOAST_MESSAGES.SUCCESS.EMAIL_DETAILS_SAVED
                        })
                    })
                    .catch((err) => {
                        toast.show({
                            title: 'Danger',
                            description: CONSTANTS.TOAST_MESSAGES.DANGER.EMAIL_DETAILS_SAVED_ERROR
                        })
                    })
                toast.show({
                    title: 'Success',
                    description: 'Email Sent Successfully'
                })
                setInputEmailTo([])
                setInputEmailCc([])
                setInputEmailBcc([])
                setSubject('')
                setAttachments([])
                setEditorState(EditorState.createEmpty());
                if (!actionOnEmail === 'reply') {
                    setCurrentTab('all')
                }
                onClose(true, true)
                return
            }).catch((err) => {
                setIsSendingEmail(false)
                toast.show({
                    title: 'Danger',
                    description: 'Unable To Sent Email'
                })
                return
            })
        }
    }

    const onHandleClose = () => {
        setShowModal(false)
        isEdit && setIsEdit(false)
    }

    const fetchDynamicOptions = debounce(async (input) => {
        dispatch(getExistingContacts({ searchValue: input, type: 'email' })).then((res) => {
            setSupplierContacts(res?.supplierContacts)
            if (res?.contacts && res?.contacts?.length > 0) {
                let createOptions = res?.contacts?.map((contact) => ({ label: contact?.email, value: contact?.id, supplierIds: contact?.supplierIds }))
                setAllContacts([...createOptions])
                // if (initialAllContacts?.length === 0) {
                //     setInitialAllContacts([...allContacts])
                // }

            } else {
                setAllContacts([])
                // setInitialAllContacts([])
            }
        }).catch((err) => {
            setSupplierContacts([])
            // setInitialAllContacts([])
            toast.show({
                title: 'Warning',
                description: 'Failed To Get Existing Contact!'
            })
        });
    }, 1000)

    const onEditContact = (e, contactId) => {
        e.stopPropagation()
        setIsEdit(true)
        setContactIdToEdit(contactId)
    }
    const onAddNewContact = () => {
        setShowModal(true)
    }

    const CustomOption = (props) => {
        if (props.data.header && props?.data?.label === 'AddButton') {
            return (
                <components.Option {...props} >
                    {props?.data?.label !== 'No Contacts' && input === '' && <div className='col-4 d-flex justify-content-end w-100'>
                        <button type="button" class="fs-4 text-white rounded ps-3 pe-3 py-2 bg-dark-blue" onClick={() => { onAddNewContact() }}>Add New Contact</button>
                    </div>}
                </components.Option>
            );
        } else if (props.data.header) {
            return (
                <components.Option {...props} >
                    <div className='d-flex align-items-center justify-content-between font-weight-bold  w-100' >
                        {props?.data?.label !== 'No Contacts' && <div className='col-4 '>
                            <span className='text-blue fw-bold'>Contact Name</span>
                        </div>}
                        <div className='col-4 '>
                            <span
                                className='text-blue fw-bold'
                                style={{ color: '#214466' }}
                            >
                                {props?.data?.label !== 'No Contacts' ? "Email" : "No Contacts"}
                            </span>
                        </div>
                        {props?.data?.label !== 'No Contacts' && <div className='col-4 d-flex justify-content-end'>
                            <span className='text-blue fw-bold'>Action</span>
                        </div>}

                    </div>
                </components.Option>
            );
        } else {
            return (
                <components.Option {...props}>
                    <div className='d-flex justify-content-between'>
                        <div className='col-4 '>
                            <span >{props.data.name}</span>
                        </div>
                        <div className='col-4 '>
                            <span>{props.data.label}</span>
                        </div>
                        {!props?.data?.__isNew__ && <div className='col-4 d-flex column-gap-4 justify-content-end'>
                            <button><BiEdit color='#214466' size={30} onClick={(e) => { onEditContact(e, props?.data?.value) }} /></button>
                            {!props?.data?.supplierIds || (props?.data?.supplierIds?.length > 0 && props?.data?.supplierIds?.includes(supplierInfo?.id)) ? (
                                <button><FiLink color='#198754' size={26} /></button>
                            ) : (
                                <button><FiLink color='red' size={26} /></button>
                            )}

                        </div>}
                    </div>
                </components.Option>
            );
        }
    };

    const CustomOptionForFrom = (props) => {
        const { data, innerRef, innerProps } = props;

        if (data.label === "header") {
            return null;
        }

        return (
            <div ref={innerRef} {...innerProps} className="d-flex justify-content-between align-items-center p-3" style={{ cursor: 'pointer' }}>
                <p className='p-1 m-0'>{data.label}</p>
                {data.isDefault && <p className='fw-bold m-0' style={{ color: '#214466' }}>(Default)</p>}
            </div>
        );
    };


    const onSetContacts = useCallback(async () => {
        let tmpAllContacts = contacts?.map((contact) => {
            return {
                label: contact?.email,
                name: contact?.contactName,
                value: contact?.id,
            }
        })?.filter((contact) => contact?.label)
        setAllContacts(tmpAllContacts)
        setExistingContacts(tmpAllContacts)
    }, [contacts])

    const onChangeEmail = (e, field) => {
        if (e?.length === 0) {
            setAllContacts([...existingContacts])
        } else {
            if (e[e?.length - 1]?.__isNew__ && e[e.length - 1]?.label !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(e[e.length - 1]?.label)) {
                toast.show({
                    title: 'Warning',
                    description: 'Email Address must be in email format!'
                })
            } else {
                field === 'to' ? setInputEmailTo(e) : field === 'cc' ? setInputEmailCc(e) : field === 'from' ? setInputEmailFrom(e) : setInputEmailBcc(e)
                field === 'to' ? setEmailActiveField('to') : field === 'cc' ? setEmailActiveField('cc') : setEmailActiveField('bcc')
    
                if (e?.length > inputEmailTo?.length || e?.length > inputEmailCc?.length || e?.length > inputEmailBcc?.length) {
                    if (!e[e?.length - 1]?.__isNew__) {
                        let contactId = e[e?.length - 1]?.value
                        let isContactLinked = supplierContacts?.filter((contact) => contact?.contactId === contactId)
    
                        let isContactExistForSup = contacts?.findIndex((contact) => contact?.id === contactId)
                        let tmpIsContactLinkedWithSup = isContactLinked?.filter(contact => contact?.supplierId === supplierInfo?.id)
                        let tmpIsContactLinkedWithLs = isContactLinked?.filter(contact => contact?.listSupplierId === vendorInfo?.id)
                        setexistingContactId(contactId)
                        setIsContactLinkedWithSup(tmpIsContactLinkedWithSup)
                        setIsContactLinkedWithLs(tmpIsContactLinkedWithLs)
    
                        if ((tmpIsContactLinkedWithSup?.length === 0 && tmpIsContactLinkedWithLs?.length) === 0 && isContactExistForSup === -1) {
                            setShowLinkModal(true)
                        }
                    }
                }
            }
        } 
    }

    const onInputChange = (e) => {
        setInput(e)
        if (e?.length === 0) {
            setAllContacts([...existingContacts])
        } else if (e.length > 4) {
            fetchDynamicOptions(e)
        }
    }

    const onFocusHandler = () => {
        onSetContacts()
    }

    const onBlurHandler = async () => {
        setAllContacts(existingContacts)
    }

    const onCustomAddContact = (emailValue) => {
        if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
            setShowModal(false)

        } else {
            setShowModal(true)
        }
    }

    const customCreateLabel = (inputValue) => {
        return (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} className=' justify-content-end'>
                <button type="button" class="fs-4 text-white rounded ps-3 pe-3 py-2 bg-dark-blue " onClick={() => { onCustomAddContact(inputValue) }}>Add New Contact</button>
            </div>
        )
    }

    const linkExistingContactToSup = async () => {
        let dataToPass = {}
        let queryOp = 'create'
        if (!supplierInfo?.id) {
            if (vendorInfo?.id && isContactLinkedWithLs?.length > 0) {
                const islinkWithLs = isContactLinkedWithLs?.find(contact => contact?.isInCalls)
                if (islinkWithLs) {
                    return
                } else {//update
                    queryOp = 'update'
                    dataToPass = { contactInfo: { id: existingContactId }, supplierId: null, listSupplierId: vendorInfo?.id, isInCalls: true, vendorInCallsDetailsId: null } // create a new record
                }
            } else {
                dataToPass = { contactInfo: { id: existingContactId }, supplierId: null, listSupplierId: vendorInfo?.id, isInCalls: true, vendorInCallsDetailsId: null, isContactExist: true } // create a new record
            }
        } else {
            if (vendorInfo?.id && isContactLinkedWithLs?.length === 0 && supplierInfo?.id && isContactLinkedWithSup?.length === 0) { // not linked with both
                dataToPass = { contactInfo: { id: existingContactId }, supplierId: supplierInfo?.id, listSupplierId: vendorInfo?.id, isInCalls: false, vendorInCallsDetailsId: null, isContactExist: true } // create a new record
            } else if ((vendorInfo?.id && isContactLinkedWithLs?.length >= 0) && (supplierInfo?.id && isContactLinkedWithSup?.length === 0)) { //linked with ls but not with sup // update
                queryOp = 'update'
                dataToPass = { contactInfo: { id: existingContactId }, supplierId: supplierInfo?.id, listSupplierId: vendorInfo?.id, isInCalls: false, vendorInCallsDetailsId: null, isContactExist: true } // create a new record
            }
        }

        if (queryOp === 'create') {
            dispatch(createContact({ ...dataToPass, linkToSupplier: true })).then(result => {
                toast.show({
                    title: 'Success',
                    description: 'Contact created successfully!'
                })
                setShowLinkModal(false);
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to create contact!'
                })
            })
        } else {
            dispatch(updateSupplierContact(dataToPass)).then(result => {
                toast.show({
                    title: 'Success',
                    description: 'Contact created successfully!'
                })
                setShowLinkModal(false);
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to create contact!'
                })
            })
        }

        await getContactsData(supplierInfo?.id)
    }


    const emailListHandler = useCallback(async () => {
       await dispatch(getEmailListForUser()).then((res) => {
            let tmpDefaultEmail = res?.filter((mail) => mail.isDefaultEmail)[0]
            let tmpUserRegisteredEmails = res?.map((mail) => {
                if (mail?.emailSignature) {
                    const htmlString = mail?.emailSignature
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(htmlString, "text/html");
                    const plainText = doc.body.textContent || "";
                    mail['emailSignatureAsPlainText'] = plainText
                }
                return {
                    label: mail?.email,
                    value: mail?.id,
                    isDefault: mail?.isDefaultEmail,
                    domain: mail?.domain,
                    accessToken: mail?.accessToken,
                    refreshToken: mail?.refreshToken,
                    emailSignature: mail?.emailSignature
                }
            })
            setUserRegisteredEmails(tmpUserRegisteredEmails)
            setUserDefaultEmail(tmpDefaultEmail)

            if (Object?.keys(oldEmailDataInContext)?.length > 0) {
                let filterEmailToSendFrom = res?.filter((email) => email?.email?.toLowerCase() === oldEmailDataInContext?.receiverEmail?.toLowerCase())[0]
                setInputEmailFrom({ label: filterEmailToSendFrom?.email, value: filterEmailToSendFrom?.id, isDefault: filterEmailToSendFrom?.isDefaultEmail, domain: filterEmailToSendFrom?.domain, accessToken: filterEmailToSendFrom?.accessToken, emailSignature: filterEmailToSendFrom?.emailSignature, refreshToken: filterEmailToSendFrom?.refreshToken })
            } else {
                setInputEmailFrom({ label: tmpDefaultEmail?.email, value: tmpDefaultEmail?.id, isDefault: tmpDefaultEmail?.isDefaultEmail, domain: tmpDefaultEmail?.domain, accessToken: tmpDefaultEmail?.accessToken, emailSignature: tmpDefaultEmail?.emailSignature, refreshToken: tmpDefaultEmail?.refreshToken })
            }
        }).catch((err) => {
            if (err.message === "Network Error") {
                toast.show({
                    title: "Warning",
                    description: "Check your internet connection and try again."
                });
            } else {
                toast.show({
                    title: 'Danger',
                    description: 'Unable To Get The Registered Emails'
                })
            }
            setUserDefaultEmail({})
        })
    }, [componentFor])

    useEffect(() => {
        emailListHandler()
        if (componentFor === 'tasks' || componentFor === 'tasksInEmailDetail' || componentFor === 'notificationDetail') {
            if (actionOnEmailForTask === 'reply') {
                let inputTo = { label: selectedFormatedEmail?.senderEmail, value: selectedFormatedEmail?.senderEmail }
                let inputFrom = { label: selectedFormatedEmail?.receiverEmail, value: selectedFormatedEmail?.receiverEmail }
                setInputEmailTo([inputTo])
                setInputEmailFrom([inputFrom])
                setSubject(selectedFormatedEmail?.subject)
            } else if (actionOnEmailForTask === 'forward') {
                let inputFrom = { label: selectedFormatedEmail?.receiverEmail, value: selectedFormatedEmail?.receiverEmail }

                setInputEmailTo([])
                setInputEmailFrom([inputFrom])
                let tmpSubject = `Fw:${selectedFormatedEmail?.subject}`
                setSubject(tmpSubject)
                let formattedBody = "";

                formattedBody += `<p><b>From:</b> ${selectedFormatedEmail.senderEmail}<br/>`;
                formattedBody += `<b>To:</b> ${selectedFormatedEmail.receiverName}<br/>`;
                formattedBody += `<b>Date:</b> ${selectedFormatedEmail.sentDate}<br/>`;
                formattedBody += `<b>Subject:</b> ${selectedFormatedEmail.subject}</p>`;
                formattedBody += `<p>${selectedFormatedEmail.mainBody}</p>`;
                formattedBody += `<hr/>`;

                const blocksFromHTML = convertFromHTML(formattedBody);
                const contentState = ContentState.createFromBlockArray(
                    blocksFromHTML.contentBlocks,
                    blocksFromHTML.entityMap
                );

                setEditorState(EditorState.createWithContent(contentState));
            }
        } else {
            if (activeTab === 'notes') {
                if (actionOnEmail === 'replyAll' && (oldEmailDataInContext?.Cc?.length > 0)) {
                    setShowCC(true)
                    let tmpInputEmailCc = oldEmailDataInContext?.Cc?.map((data) => {
                        return {
                            label: data,
                            value: data
                        }
                    })
                    setInputEmailCc(tmpInputEmailCc)
                    setInputEmailHandler(oldEmailDataInContext)
                } else if (actionOnEmail === 'reply') {
                    setInputEmailHandler(oldEmailDataInContext)
                } else if (actionOnEmail === 'forward') {
                    if (forwardConversation?.length > 0) {
                        let formattedBody = "";
                        forwardConversation.forEach((message) => {
                            formattedBody += `<p><b>From:</b> ${message.senderEmail}<br/>`;
                            formattedBody += `<b>To:</b> ${message.receiverName}<br/>`;
                            formattedBody += `<b>Date:</b> ${message.sentDate}<br/>`;
                            formattedBody += `<b>Subject:</b> ${message.subject}</p>`;
                            formattedBody += `<p>${message.mainBody}</p>`;
                            formattedBody += `<hr/>`;
                        });
                        const blocksFromHTML = convertFromHTML(formattedBody);
                        const contentState = ContentState.createFromBlockArray(
                            blocksFromHTML.contentBlocks,
                            blocksFromHTML.entityMap
                        );

                        setEditorState(EditorState.createWithContent(contentState));
                    } else {
                        setInputEmailTo([])
                        setInputEmailCc([])
                        setInputEmailBcc([])
                        setSubject('')
                    }
                }
            } else {
                setInputEmailTo([])
                setInputEmailCc([])
                setInputEmailBcc([])
                setSubject('')
                setEditorState(EditorState?.createEmpty())
            }
        }


    }, [oldEmailDataInContext, forwardConversation, activeTab, emailListHandler])

    return (
        <div className={`caller-notes-container d-flex row-gap-5 flex-column border rounded p-4 gap-3 flex-grow-1 `}>
            <div className='p-0 m-0 d-flex flex-column row-gap-3'>
                <div className='d-flex justify-content-end w-100 '>
                    <div className='d-flex column-gap-4 '>
                        <label className='fw-bold fs-4 text-black' onClick={() => { setShowFrom(!showFrom) }}>FROM</label>
                        <label className='fw-bold fs-4 text-black' onClick={() => { setShowCC(!showCC) }}>CC</label>
                        <label className='fw-bold fs-4 text-black' onClick={() => { setShowBCC(!showBCC) }}>BCC</label>
                    </div>
                </div>

                {componentFor !== 'addCallerDetails' && componentFor !== 'masterSupplierDetail' && componentFor !== 'relatedSupplierDetails' && componentFor !== 'tasks' && <div className='d-flex flex-column align-items-center w-100' style={{ height: showThread ? 'auto' : 40 }} >
                    <div className=' d-flex align-items-center w-100 column-gap-4' style={{ marginRight: 5 }}>
                        <h3 className='m-0 fw-bold fs-4 text-black'>Email History</h3>
                        {showThread ? <div className='d-flex align-items-center'><i class="bi bi-dash-circle fs-2" color='#214466' onClick={() => { setShowThread(false) }}></i></div> : <div className='d-flex align-items-center'><i class="bi bi-plus-circle fs-2" color='#214466' onClick={() => { setShowThread(true) }}></i></div>}
                    </div>
                    {showThread && <div
                        style={{ padding: "10px", fontSize: 16, height: 400, overflowY: 'scroll' }}
                        className='border mt-3 rounded w-100  no-scrollbar'
                    >
                        {
                            emailConversation?.map((emailHistory, index) => {
                                return (
                                    <div key={index} className={`border p-3 w-100 d-flex mb-3 ${emailHistory?.isSent ? 'justify-content-start' : 'justify-content-end'}`}>
                                        <div style={{ width: '90%' }}>
                                            <div className={`d-flex justify-content-between w-100 `}>
                                                <p className='fw-bold m-0 fs-5' style={{ color: '#214466', letterSpacing: 1 }} >{emailHistory?.senderEmail} {' -> '} {emailHistory?.receiverEmail}</p>
                                                <p className='fw-bold fs-5 m-0' style={{ color: '#214466', letterSpacing: 1 }}>( {emailHistory?.timeSpan} )</p>
                                            </div>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(emailHistory?.mainBody),
                                                }}
                                                style={{ border: "1px solid #ccc", padding: "10px", fontSize: 16 }}
                                                className='mt-3 rounded w-100'
                                            >
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>}
                </div>}
                {
                    <Modal show={showLinkModal} onHide={() => { setShowLinkModal(false) }} size='lg'>
                        <Modal.Header>
                            <p className='text-center fs-2'>Link contact <span className='text-blue fw-bold'>{emailEntered?.value}</span> to this Supplier {supplierInfo?.suppliername || ''} ?</p>
                        </Modal.Header>
                        <Modal.Body>
                            <div className='d-flex align-items-center justify-content-center column-gap-3'>
                                <button className='report_small_button_grey' onClick={() => { setShowLinkModal(false) }}>Cancel</button>
                                <button className='report_small_button_success' onClick={() => { linkExistingContactToSup() }}>Link</button>
                            </div>
                        </Modal.Body>
                    </Modal>
                }
                {
                    <Modal show={showModal || isEdit} onHide={() => { onHandleClose() }} size='lg'>
                        <Modal.Body>
                            {<CreateContact
                                supplierId={supplierInfo?.id || null}
                                listSupplierId={supplierInfo?.id ? null : vendorInfo?.id}
                                vendorInCallsDetailsId={vendorInCallDetailsId}
                                supplierName={supplierInfo?.suppliername || null}
                                vendorInfo={vendorInfo}
                                onClose={onHandleClose}
                                contactId={contactIdToEdit}
                                contactDataFromField={{}}
                                isInCalls={supplierInfo?.id ? null : true}
                                inputEmail={inputEmail}
                                getContactsData={getContactsData}
                                activeTab={activeTab}
                                setShowModal={setShowModal}
                                isEdit={isEdit}
                                emailEntered={activeEmailField === 'to' ? inputEmailTo?.[inputEmailTo?.length - 1] : activeEmailField === 'cc' ? inputEmailCc?.[inputEmailCc?.length - 1] : inputEmailBcc?.[inputEmailBcc?.length - 1]}
                            ></CreateContact>
                            }
                        </Modal.Body>
                    </Modal>
                }


                <label className='fw-bold fs-4 text-black'>To</label>
                <CreatableSelect
                    styles={{
                        container: (base) => ({
                            ...base,
                            zIndex: 100
                        }),
                        control: (base) => ({
                            ...base,
                            backgroundColor: 'white'
                        }),
                        option: (base, { isFocused }) => ({
                            ...base,
                            backgroundColor: isFocused ? 'transparent' : 'white',
                            color: 'black'
                        }),
                        dropdownIndicator: (base) => ({
                            ...base,
                            color: 'black'
                        })
                    }}
                    className="h4 w-100 h-100"
                    classNamePrefix='react-select-selector'
                    value={inputEmailTo}
                    isMulti
                    onChange={(e) => { onChangeEmail(e, 'to') }}
                    options={allContacts.length > 0 ? [
                        { header: true, label: 'AddButton', listId: 'Header', isDisabled: true, onEdit: onEditContact },
                        { header: true, label: 'Header', listId: 'Header', isDisabled: true, onEdit: onEditContact },
                        ...allContacts
                    ] : [
                        { header: true, label: 'No Contacts', listId: 'Header', isDisabled: true },
                    ]}
                    onFocus={onFocusHandler}
                    onBlur={onBlurHandler}
                    components={{ Option: CustomOption }}
                    onInputChange={(e) => { onInputChange(e) }}
                    formatCreateLabel={customCreateLabel}
                    onMenuOpen={() => { onSetContacts() }}
                />
            </div>

            {showFrom && <div className=' p-0 m-0 d-flex flex-column row-gap-3'>
                <label className='fw-bold fs-4 text-black'>From</label>
                <Select
                    className="h4 w-100 h-100"
                    classNamePrefix="react-select-selector"
                    value={inputEmailFrom?.length !== 0 ? inputEmailFrom : { label: userDefaultEmail?.email, value: userDefaultEmail?.id }}
                    onChange={(e) => { onChangeEmail(e, "from") }}
                    options={[{ label: "header" }, ...userRegisteredEmails]}
                    components={{ Option: CustomOptionForFrom }}
                    styles={{
                        container: (baseStyles) => ({
                            ...baseStyles,
                            zIndex: 100
                        })
                    }}
                />
            </div>}

            {showCC && <div className=' p-0 m-0 d-flex flex-column row-gap-3'>
                <label className='fw-bold fs-4 text-black'>CC</label>
                <CreatableSelect
                    onClick={() => { }}
                    className="h4 w-100 h-100"
                    classNamePrefix='react-select-selector'
                    value={inputEmailCc}
                    isMulti
                    onChange={(e) => { onChangeEmail(e, 'cc') }}
                    options={allContacts.length > 0 ? [
                        { header: true, label: 'Header', listId: 'Header', isDisabled: true },
                        ...allContacts
                    ] : [
                        { header: true, label: 'No Contacts', listId: 'Header', isDisabled: true },
                    ]}
                    onFocus={onFocusHandler}
                    onBlur={onBlurHandler}
                    components={{ Option: CustomOption }}
                    onInputChange={(e) => { onInputChange(e) }}
                    formatCreateLabel={customCreateLabel}
                />
            </div>}
            {showBCC && <div className=' p-0 m-0 d-flex flex-column row-gap-3'>
                <label className='fw-bold fs-4 text-black'>BCC</label>
                <CreatableSelect
                    onClick={() => { }}
                    className="h4 w-100 h-100"
                    classNamePrefix='react-select-selector'
                    value={inputEmailBcc}
                    isMulti
                    onChange={(e) => { onChangeEmail(e, 'bcc') }}
                    options={allContacts.length > 0 ? [
                        { header: true, label: 'Header', listId: 'Header', isDisabled: true },
                        ...allContacts
                    ] : [
                        { header: true, label: 'No Contacts', listId: 'Header', isDisabled: true },
                    ]}
                    onFocus={onFocusHandler}
                    onBlur={onBlurHandler}
                    components={{ Option: CustomOption }}
                    onInputChange={(e) => { onInputChange(e) }}
                    formatCreateLabel={customCreateLabel}
                />
            </div>}
            <div className=' p-0 m-0 d-flex flex-column row-gap-3'>
                <label className='fw-bold fs-4 text-black'>Subject</label>
                <input className='form-control' style={{ height: 48, fontSize: 16 }} value={subject} onChange={(e) => { setSubject(e.target.value) }} />
            </div>
            <div className=' p-0 m-0 d-flex flex-column row-gap-3'>
                <label className='fw-bold fs-4 text-black'>Body</label>
                <div style={{ border: '1px solid #ddd', padding: 10, width: '100%', maxWidth: 800 }}>
                    <Editor
                        editorStyle={{
                            padding: 10,
                            height: '250px',
                            maxWidth: '100%',
                            boxSizing: 'border-box',
                            overflowX: 'hidden',
                            wordWrap: 'break-word',
                            whiteSpace: 'normal',
                            img: {
                                display: 'block',
                                marginLeft: '0',
                                marginRight: 'auto',
                            },
                        }}
                        editorState={editorState}
                        toolbarClassName="sticky-toolbar"
                        wrapperClassName="wrapperClassName"
                        editorClassName="scrollable-editor-content no-scrollbar"
                        onEditorStateChange={onEditorStateChange}
                        placeholder="Start typing here..."
                    />
                </div>
            </div>
            <div className="file-upload-container w-50" style={{ cursor: 'pointer' }}>
                <input
                    hidden
                    type="file"
                    id="fileInput"
                    multiple
                    onChange={handleFileUpload}
                    className="hidden-file-input"
                />

                <div className=' d-flex column-gap-3' style={{ cursor: 'pointer' }}>
                    <label htmlFor="fileInput" className="custom-upload-button fs-3 m-0 d-flex column-gap-2 align-items-start w-auto">
                        <LuPaperclip className='fs-2' style={{ cursor: 'pointer' }} /><p style={{ cursor: 'pointer' }} className='fs-4 m-0 fw-bold'>Add Attachments</p>
                    </label>


                    {attachments.length > 0 && (
                        <ul className="">
                            {attachments.map((fileName, index) => (
                                <li className='fs-4' key={fileName?.filename}>{fileName?.filename}<span style={{ marginLeft: 10 }}><ImCross color='#fa5050' size={12} onClick={() => { removeFile(fileName?.filename) }} /></span></li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
            <div className='py-3 px-3 w-100 border rounded d-flex align-items-center flex-column ' style={{ height: showSignature ? 'auto' : 50, cursor: 'pointer' }} onClick={() => { setShowSignature(!showSignature) }}>
                <div className='d-flex justify-content-between align-items-center w-100'>
                    <label className='fw-bold fs-4 text-black'>Signature</label>
                </div>
                {showSignature &&
                    <div
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(convertContentToHtml(inputEmailFrom?.emailSignature)),
                        }}
                        style={{ border: "1px solid #ccc", padding: "10px" }}
                        className='mt-3 rounded fs-4 w-100'
                    >
                    </div>
                }
            </div>
            <div className='d-flex justify-content-end column-gap-4'>
                <button className='report_button_secondary' onClick={() => { setShow(false) }}>Cancel</button>
                {isSendingEmail ? <div className='d-flex justify-content-center align-items-center'><Loader style={{color: '#58CF6B'}} /></div> : <button className='report_button_success' onClick={onSendEmail} >Send</button>}
            </div>
        </div>
    )
}

export default ComposeEmail;